import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Modal, Button, Collapse } from 'react-bootstrap';
import { FaCalendarAlt, FaChevronDown, FaChevronUp, FaFilter } from 'react-icons/fa';
import './Filters.css';
import { useSearchParams } from 'react-router-dom';
import CustomDropdown from './CustomDropdown';
import { enUS } from 'date-fns/locale';

const Filters = ({ setCurrentPage }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');

  useEffect(() => {
    setSearchTerm(searchParams.get('search') || '');
  }, [searchParams]);

  const handleSearchSubmit = () => {
    setSearchParams(prevParams => {
      // Preserve category logic
      const currentCategory = prevParams.get('category');
      if (!(currentCategory === '300')) {
        prevParams.delete('category');
      }
      prevParams.delete('page');

      if (searchTerm.trim()) {
        prevParams.set('search', searchTerm.trim());
      } else {
        prevParams.delete('search');
      }
      return prevParams;
    });
    setCurrentPage(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit();
    }
  };


  const [dateRange, setDateRange] = useState({
    startDate: new Date(searchParams.get('startDate') || new Date()),
    endDate: new Date(searchParams.get('endDate') || new Date()),
    key: 'selection'
  });

  const formatDate = (date) => {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  };

  const cardTypes = [
    { label: "All", value: "" },
    { label: "Minion", value: "Minion" },
    { label: "Spell", value: "Spell" },
    { label: "Weapon", value: "Weapon" },
    { label: "Location", value: "Location" },
    { label: "Hero", value: "Hero" },
    { label: "Hero Card", value: "Herocard" }
  ];

  const classes = [
    { label: "All", value: "" },
    { label: "Death Knight", value: "DeathKnight", image: "/images/class-icons/death-knight.png" },
    { label: "Demon Hunter", value: "Demon Hunter", image: "/images/class-icons/demon-hunter.png" },
    { label: "Druid", value: "Druid", image: "/images/class-icons/druid.png" },
    { label: "Hunter", value: "Hunter", image: "/images/class-icons/hunter.png" },
    { label: "Mage", value: "Mage", image: "/images/class-icons/mage.png" },
    { label: "Paladin", value: "Paladin", image: "/images/class-icons/paladin.png" },
    { label: "Priest", value: "Priest", image: "/images/class-icons/priest.png" },
    { label: "Rogue", value: "Rogue", image: "/images/class-icons/rogue.png" },
    { label: "Shaman", value: "Shaman", image: "/images/class-icons/shaman.png" },
    { label: "Warlock", value: "Warlock", image: "/images/class-icons/warlock.png" },
    { label: "Warrior", value: "Warrior", image: "/images/class-icons/warrior.png" },
    { label: "Neutral", value: "Neutral", image: "/images/class-icons/neutral.png" }
  ];

  const costs = [
    { label: "All", value: "" },
    ...[...Array(11).keys()].map(i => ({ label: i.toString(), value: i }))
  ];
  const attacks = [
    { label: "All", value: "" },
    ...[...Array(11).keys()].map(i => ({ label: i.toString(), value: i }))
  ];
  const healths = [
    { label: "All", value: "" },
    ...[...Array(11).keys()].map(i => ({ label: i.toString(), value: i }))
  ];

  const rarities = [
    { label: "All", value: "" },
    { label: "Free", value: "Free", image: "/images/rarity-icons/free.webp" },
    { label: "Common", value: "Common", image: "/images/rarity-icons/common.webp" },
    { label: "Rare", value: "Rare", image: "/images/rarity-icons/rare.webp" },
    { label: "Epic", value: "Epic", image: "/images/rarity-icons/epic.webp" },
    { label: "Legendary", value: "Legendary", image: "/images/rarity-icons/legendary.webp" }
  ];

  const orders = [
    { label: "Date Descending", value: "date_desc" },
    { label: "Date Ascending", value: "date_asc" },
    { label: "Rating Descending", value: "rating_desc" },
    { label: "Rating Ascending", value: "rating_asc" },
    { label: "Cost Descending", value: "cost_desc" },
    { label: "Cost Ascending", value: "cost_asc" }
  ];

  // const handleFilterChange = (selectedOption, name) => {
  //   setSearchParams(prevParams => {
  //     prevParams.delete('category');
  //     prevParams.delete('page');
  //     if (selectedOption.value) {
  //       prevParams.set(name, selectedOption.value);
  //     } else {
  //       prevParams.delete(name);
  //     }
  //     return prevParams;
  //   });
  //   setCurrentPage(1);
  // };

  const handleFilterChange = (selectedOption, name) => {
    setSearchParams(prevParams => {
    // Get the current category value before making changes
    const currentCategory = prevParams.get('category');
    
    // Only delete category if it's not already 300
    if (!(currentCategory === '300')) {
      prevParams.delete('category');
    }
      prevParams.delete('page');
      if (selectedOption.value !== "") { // Allow 0 as a valid value
        prevParams.set(name, selectedOption.value);
      } else {
        prevParams.delete(name);
      }
      return prevParams;
    });
    setCurrentPage(1);
  };
  

  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    setDateRange(selection);
    setSearchParams(prevParams => {
      prevParams.set('startDate', selection.startDate.toISOString().split('T')[0]);
      prevParams.set('endDate', selection.endDate.toISOString().split('T')[0]);
      return prevParams;
    });
    setCurrentPage(1);
  };

  const handleApplyDateRange = () => {
    setShowDatePicker(false);
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    setSearchParams({});
    setDateRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    });
    setCurrentPage(1);
  };

  return (
    <div className="filters mt-4">
      <div className="row mb-1 w-100">
        <div className="w-100">
          <button
            className="btn btn-secondary w-100 d-flex justify-content-between align-items-center"
            onClick={() => setShowFilters(!showFilters)}
          >
            <FaFilter /> Filters
            {showFilters ? <FaChevronUp /> : <FaChevronDown />}
          </button>
        </div>
      </div>
      <Collapse in={showFilters} className="w-100">
        <div>

          <div className="row">
             <div className="w-100">
               <div className="input-group">
                 <input
                   type="text"
                   className="form-control name-filter filter"
                   placeholder="Card Name, Card Text"
                   value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)}
                   onKeyDown={handleKeyDown}
                 />
               </div>
             </div>
          </div>

          <div className="row mb-3">
            <div className="w-100">
              <CustomDropdown
                options={cardTypes}
                selected={cardTypes.find(option => option.value === searchParams.get('cardtype'))}
                onSelect={(option) => handleFilterChange(option, 'cardtype')}
                label="Card Type"
                image="/images/cardtype.png"
              />
            </div>
            <div className="w-100">
              <CustomDropdown
                options={classes}
                selected={classes.find(option => option.value === searchParams.get('class'))}
                onSelect={(option) => handleFilterChange(option, 'class')}
                label="Class"
                image="/images/cardclass.png"
              />
            </div>
            <div className="w-100">
              <CustomDropdown
                options={costs}
                selected={costs.find(option => option.value == searchParams.get('cost'))}
                onSelect={(option) => handleFilterChange(option, 'cost')}
                label="Cost"
                image="/images/cost.webp"
              />
            </div>
            <div className="w-100">
              <CustomDropdown
                options={attacks}
                selected={attacks.find(option => option.value == searchParams.get('attack'))}
                onSelect={(option) => handleFilterChange(option, 'attack')}
                label="Attack"
                image="/images/attack.png"
              />
            </div>
            <div className="w-100">
              <CustomDropdown
                options={healths}
                selected={healths.find(option => option.value == searchParams.get('health'))}
                onSelect={(option) => handleFilterChange(option, 'health')}
                label="Health"
                image="/images/health.png"
              />
            </div>
            <div className="w-100">
              <CustomDropdown
                options={rarities}
                selected={rarities.find(option => option.value == searchParams.get('rarity'))}
                onSelect={(option) => handleFilterChange(option, 'rarity')}
                label="Rarity"
                image="/images/rarity-icons/common.webp"
              />
            </div>
          </div>
          <div className="row">
            <div className="w-100">
              <label>Date Range:</label>
              <button
                type="button"
                className="btn btn-secondary w-100 filter"
                onClick={() => setShowDatePicker(true)}
              >
                <FaCalendarAlt /> {searchParams.get('startDate') ? `${formatDate(dateRange.startDate)} - ${formatDate(dateRange.endDate)}` : 'Date'}
              </button>
              <Modal show={showDatePicker} onHide={() => setShowDatePicker(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>Select Date Range</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <DateRangePicker 
                    minDate={new Date('01/01/2014')}
                    maxDate={new Date()}
                    ranges={[dateRange]}
                    onChange={handleDateRangeChange}
                    locale={enUS}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowDatePicker(false)}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handleApplyDateRange}>
                    Apply
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
            <div className="w-100">
              <CustomDropdown
                options={orders}
                selected={orders.find(option => option.value === searchParams.get('order'))}
                onSelect={(option) => handleFilterChange(option, 'order')}
                label="Order By"
                image="/images/order.png" // Replace with your image path
              />
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="w-100">
              <button 
                className="btn btn-danger w-100" 
                onClick={handleResetFilters}
              >
                Reset Filters
              </button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default Filters;
